import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CsvUploadSteps from './CsvUploadSteps';
import { ReplaceCompanyListItems } from 'services/companyList';

export interface ICsvData {
  key: number;
  rowNumber: number;
  companyName: string;
  countryCode3: string;
  companyNumber?: string;
}

export interface IInvalidData {
  key: number;
  rowNumber: number;
  column: string;
  error: string;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

interface IProps {
  companyListId: string;
  visible: boolean;
  onClose: () => void;
  onFinish: () => void;
}
export default function CsvUploadDialog(props: IProps) {
  const { visible, onClose, onFinish, companyListId } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(visible);
  }, [visible]);

  const handleClose = () => {
    onClose();
  };

  const handleReplaceCompanyList = async (array: ICsvData[]) => {
    const list = array.map(item => ({
      name: item.companyName,
      countryCode: item.countryCode3,
      registrationNumber: item.companyNumber,
    }));
    await ReplaceCompanyListItems(companyListId, list);
  };

  return (
    <div>
      <BootstrapDialog
        fullWidth={true}
        maxWidth={'md'}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Upload CSV
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <CsvUploadSteps
            onUpload={handleReplaceCompanyList}
            onFinish={onFinish}
          />
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
